import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const LoadingOverlayDots: React.FC = () => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      loading: "Načítání",
    },
    en: {
      loading: "Loading",
    },
  }[language];

  return (
    <div className="relative">
      <span className="opacity-0">{copy.loading}</span>
      <span className="dots">
        <span className="dot !bg-softiq-primary"></span>
        <span className="dot !bg-softiq-primary"></span>
        <span className="dot !bg-softiq-primary"></span>
      </span>
    </div>
  );
};

export default LoadingOverlayDots;
